import { StrictMode as ReactStrictMode } from 'react';
import type { ReactNode } from 'react';

import { environment } from '../environment';

interface Props {
  readonly children: ReactNode;
}

export const StrictMode = ({ children }: Readonly<Props>) => {
  if (environment.strictMode && environment.isDevelopment) {
    return <ReactStrictMode>{children}</ReactStrictMode>;
  }

  return children;
};
